import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Agencias from '../pages/agencias';
import AgenciaForm from '../pages/agencias/AgenciaForm';
import Conciliacao from '../pages/conciliacao';
import BaixarSelecao from '../pages/conciliacao/BaixarSelecao';
import ConsultarExtratoApi from '../pages/conciliacao/ConsultarExtratoApi';
import ImportarOFX from '../pages/conciliacao/ImportarOFX';
import ContasBancarias from '../pages/contas-bancarias';
import ContaBancariaForm from '../pages/contas-bancarias/ContaBancariaForm';
import MoedasDaConta from '../pages/contas-bancarias/MoedasDaConta';
import CentrosCusto from '../pages/centros-custo';
import CentroCustoForm from '../pages/centros-custo/CentroCustoForm';
import Dashboard from '../pages/dashboard';
import Departamentos from '../pages/departamentos';
import DepartamentoForm from '../pages/departamentos/DepartamentoForm';
import Depositos from '../pages/depositos';
import CompensarDeposito from '../pages/depositos/CompensarDeposito';
import NovoDeposito from '../pages/depositos/NovoDeposito';
import Direcionadores from '../pages/direcionadores';
import DirecionadorForm from '../pages/direcionadores/DirecionadorForm';
import ExtratoBancario from '../pages/extrato-bancario';
import NovoLancamentoExtrato from '../pages/extrato-bancario/NovoLancamentoExtrato';
import LancamentosContabeis from '../pages/lancamentos';
import ChequesLancamento from '../pages/lancamentos/ChequesLancamento';
import NovoLancamento from '../pages/lancamentos/NovoLancamento';
import Moedas from '../pages/moedas';
import MonitorBancario from '../pages/monitor-bancario';
import MoedaForm from '../pages/moedas/MoedaForm';
import Notfound from '../pages/Notfound';
import PlanoContas from '../pages/plano-contas';
import PlanoContasForm from '../pages/plano-contas/PlanoContasForm';
import Saques from '../pages/saques';
import NovoSaque from '../pages/saques/NovoSaque';
import Transferencias from '../pages/transferencias';
import NovaTransferencia from '../pages/transferencias/NovaTransferencia';

const Routes: React.FC = () => {
  return (
    <Switch>
      <Route exact path="/monitor-bancario" component={MonitorBancario} />
      <Route exact path="/dashboard" component={Dashboard} />

      <Route exact path="/extrato-bancario" component={ExtratoBancario} />
      <Route
        exact
        path="/extrato-bancario/novo"
        component={NovoLancamentoExtrato}
      />

      <Route exact path="/lancamentos" component={LancamentosContabeis} />
      <Route exact path="/lancamentos/novo" component={NovoLancamento} />
      <Route
        exact
        path="/lancamentos/novo/cheques"
        component={ChequesLancamento}
      />
      <Route exact path="/conciliacao" component={Conciliacao} />
      <Route exact path="/conciliacao/baixar" component={BaixarSelecao} />
      <Route exact path="/conciliacao/importar-ofx" component={ImportarOFX} />
      <Route
        exact
        path="/conciliacao/consultar-extrato"
        component={ConsultarExtratoApi}
      />

      {/* Cadastros. As telas de cadastro e edição são rota própria, não
      pop-up: a rota mais específica vem antes para o /nova não cair na de
      edição por :id. */}
      <Route exact path="/contas-bancarias" component={ContasBancarias} />
      <Route
        exact
        path="/contas-bancarias/nova"
        component={ContaBancariaForm}
      />
      <Route
        exact
        path="/contas-bancarias/:idConta/moedas"
        component={MoedasDaConta}
      />
      <Route
        exact
        path="/contas-bancarias/:idConta"
        component={ContaBancariaForm}
      />

      <Route exact path="/agencias" component={Agencias} />
      <Route exact path="/agencias/nova" component={AgenciaForm} />
      <Route exact path="/agencias/:idAgencia" component={AgenciaForm} />

      <Route exact path="/plano-contas" component={PlanoContas} />
      <Route exact path="/plano-contas/novo" component={PlanoContasForm} />
      <Route exact path="/plano-contas/:idPlano" component={PlanoContasForm} />

      <Route exact path="/moedas" component={Moedas} />
      <Route exact path="/moedas/nova" component={MoedaForm} />
      <Route exact path="/moedas/:idMoeda" component={MoedaForm} />

      <Route exact path="/centros-custo" component={CentrosCusto} />
      <Route exact path="/centros-custo/novo" component={CentroCustoForm} />
      <Route
        exact
        path="/centros-custo/:idCentroCusto"
        component={CentroCustoForm}
      />

      <Route exact path="/departamentos" component={Departamentos} />
      <Route exact path="/departamentos/novo" component={DepartamentoForm} />
      <Route
        exact
        path="/departamentos/:idDepartamento"
        component={DepartamentoForm}
      />

      <Route exact path="/direcionadores" component={Direcionadores} />
      <Route exact path="/direcionadores/novo" component={DirecionadorForm} />
      <Route
        exact
        path="/direcionadores/:idDirecionador"
        component={DirecionadorForm}
      />

      <Route exact path="/saques" component={Saques} />
      <Route exact path="/saques/novo" component={NovoSaque} />

      <Route exact path="/depositos" component={Depositos} />
      <Route exact path="/depositos/novo" component={NovoDeposito} />
      <Route
        exact
        path="/depositos/:idDeposito/compensar"
        component={CompensarDeposito}
      />

      <Route exact path="/transferencias" component={Transferencias} />
      <Route exact path="/transferencias/nova" component={NovaTransferencia} />

      <Route exact path="*" component={Notfound} />
    </Switch>
  );
};

export default Routes;
